import React from 'react';
import { Link } from 'react-router-dom';

// Title band shared by every page: optional breadcrumb, title, meta line, and actions on the right.
function PageHeader({ title, crumb, meta, children }) {
  const metaItems = [].concat(meta || []).filter(Boolean);

  return (
    <header className="page-header">
      <div className="page-header-titles">
        {crumb && (
          <div className="page-header-crumb">
            <Link to={crumb.to}>{crumb.label}</Link> /
          </div>
        )}
        <h1>{title}</h1>
        {metaItems.length > 0 && (
          <div className="page-header-meta">
            {metaItems.map((item, i) => <span key={i}>{item}</span>)}
          </div>
        )}
      </div>
      {children && <div className="page-header-actions">{children}</div>}
    </header>
  );
}

export default PageHeader;
